import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    container: {
        height: 'calc(100vh - 58px)'
    }
});
